import { useCallback } from 'react'

import SubscriptionEvents from 'Pods/Shared/Constants/subscriptionEvents'
import useTracker from 'Pods/Shared/Hooks/useTracker'

const useSubscriptionTracking = () => {
  const { trackEvent } = useTracker()

  const trackTabView = useCallback(() => {
    trackEvent(SubscriptionEvents.PURCHASES_TAB_VIEWED, { page_type: 'purchases' })
  }, [trackEvent])

  const trackDownloadClick = useCallback((itemId, isRedownload) => {
    trackEvent(SubscriptionEvents.ITEM_DOWNLOAD_CLICK, {
      item_id: itemId,
      is_redownload: isRedownload,
    })
  }, [trackEvent])

  return {
    trackTabView,
    trackDownloadClick,
  }
}

export default useSubscriptionTracking
